module.exports = __webpack_public_path__ + "img/kreativecke.89dc6854.jpg";